import {
    faAt,
    faUser,
    faAlignJustify,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { MODULOS } from "../../../../../../Constants/Geral/Modulos";
import { DesvincularDocumentoTemplateFormularioController } from "../../../../../../Controllers/Automacao/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { IConfigTemplateFormulario } from "../../../../../../Interfaces/Automacao/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioInterfaces";
import { AlertConfirmation } from "../../../../../../Tools/SweetAlerts";

interface ILabelVinculoFormularioTemplateProps {
    documentoFormulario: IConfigTemplateFormulario;
    onDelete?: () => void;
}

export default function LabelVinculoFormularioTemplate(
    props: ILabelVinculoFormularioTemplateProps
) {
    const moduloInfo = props.documentoFormulario.ID_MODULO
        ? MODULOS.ID(props.documentoFormulario.ID_MODULO)
        : undefined;
    const { execute: deletarConfiguracao, loading: deletando } =
        useAsyncCallback(async () => {
            await AlertConfirmation(
                "Exclusão de registro",
                "Tem certeza que deseja excluir essa configuração de template para este formulário?"
            ).then(async (result) => {
                if (result.isConfirmed) {
                    await DesvincularDocumentoTemplateFormularioController(
                        props.documentoFormulario
                            .ID_DOCUMENTO_TEMPLATE_FORMULARIO
                    ).then(() => {
                        props.onDelete?.();
                    });
                }
            });
        });

    return (
        <span className="label label-light font-size-h5 h-auto label-inline d-flex flex-grow-1 justify-content-between align-items-center g-2 py-4">
            <span className="mr-4">
                <div className="d-flex align-items-center g-2">
                    <FontAwesomeIcon icon={faAt} />
                    {props.documentoFormulario.DS_DOCUMENTO}
                </div>
                {moduloInfo && (
                    <div
                        style={{
                            color: `var(${moduloInfo.color})`,
                        }}
                        className="d-flex align-items-center g-2"
                    >
                        <FontAwesomeIcon icon={faUser} />
                        {moduloInfo.DS_NOME}
                    </div>
                )}
                {props.documentoFormulario.DS_CATEGORIA_ATENDIMENTO && (
                    <div className="d-flex align-items-center g-2">
                        <FontAwesomeIcon icon={faAlignJustify} />
                        {props.documentoFormulario.DS_CATEGORIA_ATENDIMENTO}
                    </div>
                )}
            </span>
            <IconOrSpinner
                icon={faTimes}
                className="text-danger"
                role="button"
                loadingSize="sm"
                onClick={deletarConfiguracao}
                loading={deletando}
            />
        </span>
    );
}
